import React from 'react';
import {CSV_PREVIEW_ROW_LIMIT} from './csv-preview';

/**
 * Read-only render of an uploaded .csv, shown in the split dialog's document pane where a
 * PDF or image would otherwise go. Lets a user check a generated line against the row it
 * came from.
 */
export default function CsvPreviewTable({rows, translate}) {
    if (!rows?.length) {
        return (
            <div className="flex items-center justify-center h-full p-10">
                <span className="text-sm text-tm-gray-500">{translate('text.no_records')}</span>
            </div>
        );
    }

    const [header, ...body] = rows;
    const visible = body.slice(0, CSV_PREVIEW_ROW_LIMIT);

    return (
        <div className="h-full overflow-auto">
            <table className="min-w-full divide-y divide-tm-gray-200 text-xs">
                <thead className="bg-tm-gray-50 sticky top-0 z-10">
                <tr>
                    <th className="px-2 py-2 text-left font-medium uppercase tracking-wide text-tm-gray-500 whitespace-nowrap"></th>

                    {header.map((cell, index) => (
                        <th
                            key={index}
                            className="px-2 py-2 text-left font-medium uppercase tracking-wide text-tm-gray-500 whitespace-nowrap"
                        >
                            {cell}
                        </th>
                    ))}
                </tr>
                </thead>

                <tbody className="divide-y divide-tm-gray-200">
                {visible.map((row, rowIndex) => (
                    <tr key={rowIndex} className="hover:bg-tm-gray-50">
                        <td className="px-2 py-1.5 text-tm-gray-400 whitespace-nowrap">{rowIndex + 1}</td>

                        {header.map((_, cellIndex) => (
                            <td key={cellIndex} className="px-2 py-1.5 text-tm-gray-900 whitespace-nowrap">
                                {row[cellIndex] ?? ''}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>

            {body.length > visible.length && (
                <div className="px-2 py-3 text-xs text-tm-gray-500">
                    {translate('text.csv_preview_truncated', [visible.length, body.length])}
                </div>
            )}
        </div>
    );
}
